export default __webpack_public_path__ + "static/media/arrowBlack.41c368a2.svg";